<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="flex">
			<h1>Inventory cache</h1>
			<div class="flex-grow text-right">
				<button :disabled="saving" v-on:click="resetCache()">Reset cache</button>
			</div>
		</div>
		<Table class="margin-top" :perpage="100" :filters="filters" :columns="columns" :rows="rows" />
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    rows: [],
    columns: {
      id: {},
      sku: {},
      qty_stock: {}
    },
    filters: {
      qty_stock: {
        name: 'Qty.',
        mode: 'number'
      }
    }
  }),
  methods: {
    resetCache () {
      Vue.$api.post('/inventory-cache/reset', {}, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: data => alert('Done!')
      })
    },
    load () {
      Vue.$api.get('/inventory-cache', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.rows = data
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
